// config.ts
export const getGraphqlUri = () => {
  return process.env.REACT_APP_GRAPHQL_URL;
};
